export class TemplateGoal {
    templateGoalId: number;
    templateId: number;
    goalTitle: string;
    deadLine: Date;
    weight: number;
}